/*! ALL DAY FIRE - animated wordmark <adf-wordmark> v1
 * Three notches = three times of day:
 *   m  morning    the diagonal slash in the first A
 *   a  afternoon  the vertical cut through the apex of DAY's A
 *   e  evening    the level cut through the E
 * Usage: load this file once (script tag with defer), then
 *        <adf-wordmark mode="now hover" style="width:180px"></adf-wordmark>
 * mode: static | intro | now | hover | loop | scroll (space-separated, combinable)
 * settle="now"        intro ends with the current time's notch lit
 * hour="20.5"         force the time of day (0-24) instead of the visitor's clock
 * scroll-target="#id" scroll mode follows that element instead of the page
 * CSS: color (letters), --adf-fire (cut colour), --adf-glow (0-1 halo strength)
 * JS:  el.replay()
 */
(() => {
  if (!('customElements' in window) || customElements.get('adf-wordmark')) return;
  const LETTERS={"A1":"M109 0 L189 0 L280 265 L204 265 L190 222 L99 222 L81 265 L0 265 Z M148 92 L173 169 L120 169 Z","L1":"M293 0 L364 0 L364 205 L452 205 L452 265 L293 265 Z","L2":"M473 0 L544 0 L544 205 L632 205 L632 265 L473 265 Z","D":"M698 0 L698 265 L815 265 L835 260 L855 251 L868 241 L880 226 L886 214 L894 184 L895 91 L890 61 L881 40 L873 29 L861 18 L845 9 L826 3 L805 0 Z M769 59 L801 59 L812 63 L820 71 L824 80 L826 93 L825 180 L820 194 L812 202 L805 205 L768 205 Z","A2":"M981 0 L1035 0 L1134 265 L1059 265 L1045 222 L970 222 L955 265 L880 265 Z M1007 100 L1028 169 L986 169 Z","Y":"M1072 0 L1149 0 L1191 85 L1232 0 L1309 0 L1225 158 L1225 265 L1154 265 L1154 157 Z","F":"M1360 0 L1518 0 L1518 63 L1430 63 L1430 112 L1510 112 L1510 170 L1430 170 L1430 265 L1360 265 Z","I":"M1540 0 L1610 0 L1610 265 L1540 265 Z","R":"M1631 0 L1631 265 L1701 265 L1702 174 L1727 222 L1746 265 L1826 265 L1776 169 L1777 167 L1792 160 L1805 148 L1814 133 L1819 117 L1821 103 L1820 64 L1816 47 L1807 30 L1796 18 L1777 7 L1759 2 L1742 0 Z M1702 59 L1734 59 L1742 62 L1748 68 L1751 76 L1751 102 L1748 110 L1742 116 L1731 119 L1703 119 L1701 117 Z","E":"M1843 0 L2012 0 L2012 62 L1914 62 L1914 112 L2012 112 L2012 154 L1914 154 L1914 206 L2012 206 L2012 265 L1843 265 Z"};
  const NOTCHES={"m":{"x":35.51,"y":167.66,"a":-23.42,"L":117.91,"t":15},"a":{"x":1007.5,"y":-6,"a":90,"L":86,"t":15},"e":{"x":1837,"y":161.5,"a":0,"L":83,"t":15}};
  const KEYS = ['A1', 'L1', 'L2', 'D', 'A2', 'Y', 'F', 'I', 'R', 'E'];
  const HOST = { m: 'A1', a: 'A2', e: 'E' };
  const ORDER = ['m', 'a', 'e'];
  const EASE = 'cubic-bezier(.7,0,.2,1)';
  const OUT = 'cubic-bezier(.16,1,.3,1)';
  let uid = 0;

  const CSS = `adf-wordmark{display:inline-block;vertical-align:middle;line-height:0;width:240px;max-width:100%;--adf-fire:#F04A12;--adf-glow:.8}
adf-wordmark>svg{display:block;width:100%;height:auto;overflow:visible}
adf-wordmark .adf-patch{transform-box:fill-box;transform-origin:100% 50%;transform:scaleX(0)}
adf-wordmark .adf-fire,adf-wordmark .adf-halo{transform-box:fill-box;transform-origin:0 50%;fill:var(--adf-fire);opacity:0}
adf-wordmark .adf-halos{opacity:var(--adf-glow)}
adf-wordmark .adf-halo.is-breathing{animation:adf-breathe 3.6s ease-in-out infinite}
@keyframes adf-breathe{50%{opacity:.3}}
@media (prefers-reduced-motion:reduce){adf-wordmark .adf-halo.is-breathing{animation:none}}`;

  function injectCSS() {
    if (document.getElementById('adf-wordmark-css')) return;
    const s = document.createElement('style');
    s.id = 'adf-wordmark-css';
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }

  const frame = n => { const f = NOTCHES[n]; return `translate(${f.x} ${f.y}) rotate(${f.a})`; };
  const rect = (n, cls, pad, extra) => {
    const f = NOTCHES[n], h = f.t + pad * 2;
    return `<rect class="${cls}" x="0" y="${-h / 2}" width="${f.L}" height="${h}"${extra || ''}/>`;
  };

  function markup(id) {
    const notchOf = k => ORDER.find(n => HOST[n] === k);
    const mask = `<mask id="${id}k" maskUnits="userSpaceOnUse" x="-60" y="-60" width="2132" height="385">` +
      `<rect x="-60" y="-60" width="2132" height="385" fill="#fff"/>` +
      ORDER.map(n => `<g transform="${frame(n)}">${rect(n, '', 0, ' fill="#000"')}</g>`).join('') + `</mask>`;
    const clips = ORDER.map(n => `<clipPath id="${id}${n}"><path d="${LETTERS[HOST[n]]}" clip-rule="evenodd"/></clipPath>`).join('');
    const defs = `<defs>${mask}${clips}<clipPath id="${id}c"><rect x="-40" y="-80" width="2092" height="345"/></clipPath>` +
      `<filter id="${id}f" filterUnits="userSpaceOnUse" x="-160" y="-160" width="2332" height="585" color-interpolation-filters="sRGB"><feGaussianBlur stdDeviation="16"/></filter></defs>`;
    const halos = `<g class="adf-halos" filter="url(#${id}f)">` +
      ORDER.map(n => `<g transform="${frame(n)}">${rect(n, 'adf-halo', 7, ` data-n="${n}"`)}</g>`).join('') + `</g>`;
    const letters = `<g clip-path="url(#${id}c)">` + KEYS.map(k => {
      const n = notchOf(k);
      return `<g class="adf-l"><path d="${LETTERS[k]}" fill="currentColor" fill-rule="evenodd"${n ? ` mask="url(#${id}k)"` : ''}/>` +
        (n ? `<g clip-path="url(#${id}${n})"><g transform="${frame(n)}">` +
          rect(n, 'adf-patch', 1.5, ` fill="currentColor" data-n="${n}"`) + rect(n, 'adf-fire', 0.5, ` data-n="${n}"`) + `</g></g>` : '') +
        `</g>`;
    }).join('') + `</g>`;
    return `<svg viewBox="0 0 2012 265" role="img" aria-label="All Day Fire" focusable="false">${defs}${halos}${letters}</svg>`;
  }

  class ADFWordmark extends HTMLElement {
    static get observedAttributes() { return ['mode', 'hour', 'settle', 'scroll-target']; }
    constructor() { super(); this._anims = []; this._off = []; this._timers = []; }

    connectedCallback() {
      injectCSS();
      if (!this._svg) {
        this.innerHTML = markup('adfw' + (++uid) + '-');
        this._svg = this.firstElementChild;
        this._letters = [...this._svg.querySelectorAll('.adf-l')];
        this.$ = {};
        ORDER.forEach(n => {
          const q = c => this._svg.querySelector(`.${c}[data-n="${n}"]`);
          this.$[n] = { patch: q('adf-patch'), fire: q('adf-fire'), halo: q('adf-halo') };
        });
      }
      this._fit();
      if ('ResizeObserver' in window && !this._ro) { this._ro = new ResizeObserver(() => this._fit()); this._ro.observe(this); }
      this._start();
    }
    disconnectedCallback() { this._stop(); if (this._ro) { this._ro.disconnect(); this._ro = null; } }
    /* keep the ember glow visible at header sizes: blur and halo width are set in screen pixels */
    _fit() {
      const w = this.getBoundingClientRect().width;
      if (!w) return;
      const k = 2012 / w; // viewBox units per CSS pixel
      const blur = Math.min(90, Math.max(16, 7 * k));
      const pad = Math.min(40, Math.max(7, 2.5 * k));
      this._svg.querySelector('feGaussianBlur').setAttribute('stdDeviation', blur.toFixed(1));
      ORDER.forEach(n => { const r = this.$[n].halo, h = NOTCHES[n].t + pad * 2; r.setAttribute('y', -h / 2); r.setAttribute('height', h); });
    }
    attributeChangedCallback(name, oldV, newV) {
      if (!this._svg || !this.isConnected || oldV === newV) return;
      if (name === 'hour') { if (this._nowOn) this._applyNow(true); return; }
      this._stop(); this._start();
    }

    get modes() { return new Set((this.getAttribute('mode') || 'static').trim().split(/\s+/)); }
    get reduced() { return !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches); }
    hour() {
      const a = this.getAttribute('hour');
      if (a !== null && a.trim() !== '' && !isNaN(+a)) return ((+a % 24) + 24) % 24;
      const d = new Date(); return d.getHours() + d.getMinutes() / 60;
    }
    period() { const h = this.hour(); return h >= 5 && h < 12 ? 'm' : h >= 12 && h < 17 ? 'a' : 'e'; }
    replay() { this._stop(); this._start(); }

    _set(n, s) {
      const e = this.$[n];
      if ('patch' in s) e.patch.style.transform = `scaleX(${s.patch})`;
      if ('fire' in s) e.fire.style.transform = `scaleX(${s.fire})`;
      if ('fo' in s) e.fire.style.opacity = s.fo;
      if ('halo' in s) e.halo.style.transform = `scaleX(${s.halo})`;
      if ('ho' in s) e.halo.style.opacity = s.ho;
    }
    _anim(el, frames, opts) {
      if (!el.animate) return null;
      const a = el.animate(frames, Object.assign({ fill: 'both' }, opts));
      this._anims.push(a);
      return a;
    }
    _tween(el, frames, opts) {
      const a = this._anim(el, frames, opts);
      const last = frames[frames.length - 1];
      const commit = () => { for (const k in last) if (k !== 'offset' && k !== 'easing') el.style[k] = last[k]; };
      if (!a) { commit(); return; }
      a.onfinish = () => { commit(); a.cancel(); this._anims = this._anims.filter(x => x !== a); };
    }
    _later(fn, ms) { this._timers.push(setTimeout(fn, ms)); }

    _start() {
      const m = this.modes;
      this._lit = null; this._nowOn = false;
      ORDER.forEach(n => { this._set(n, { patch: 0, fire: 0, fo: 0, halo: 0, ho: 0 }); this.$[n].halo.classList.remove('is-breathing'); });
      this._letters.forEach(g => { g.style.transform = ''; });
      if (m.has('intro')) this._whenVisible(() => this._intro());
      else if (m.has('now')) this._enableNow(false);
      if (m.has('loop')) this._loop();
      if (m.has('scroll')) this._scroll();
      if (m.has('hover')) this._hover();
    }
    _stop() {
      this._anims.forEach(a => a.cancel()); this._anims = [];
      this._timers.forEach(clearTimeout); this._timers = [];
      clearInterval(this._tick);
      if (this._io) { this._io.disconnect(); this._io = null; }
      if (this._raf) { cancelAnimationFrame(this._raf); this._raf = 0; }
      this._off.forEach(f => f()); this._off = [];
      this._igniting = false;
    }
    _whenVisible(fn) {
      if (!('IntersectionObserver' in window)) return fn();
      // until it is on screen, show the finished mark (and the current cut, if settling)
      const settle = this.getAttribute('settle') === 'now' || this.modes.has('now');
      if (settle) ORDER.forEach(n => this._set(n, n === this.period() ? { fire: 1, fo: 1, halo: 1, ho: 1 } : {}));
      this._io = new IntersectionObserver(es => {
        if (es.some(e => e.isIntersecting)) { this._io.disconnect(); this._io = null; fn(); }
      }, { threshold: 0.3 });
      this._io.observe(this);
    }

    /* intro: letters rise off the baseline, then each notch is sliced open in day order */
    _intro() {
      const settle = this.getAttribute('settle') === 'now' || this.modes.has('now');
      if (this.reduced) { this._letters.forEach(g => { g.style.transform = ''; }); if (settle) this._enableNow(false); return; }
      const lit = settle ? this.period() : null;
      ORDER.forEach(n => this._set(n, { patch: 1, fire: 0, fo: 0, halo: 0, ho: 0 }));
      this._letters.forEach((g, i) => this._tween(g,
        [{ transform: 'translateY(290px)' }, { transform: 'translateY(0px)' }],
        { duration: 760, delay: i * 50, easing: OUT }));
      ORDER.forEach((n, i) => {
        const d = 640 + i * 300, e = this.$[n], keep = n === lit;
        this._tween(e.patch, [{ transform: 'scaleX(1)' }, { transform: 'scaleX(0)' }], { duration: 330, delay: d, easing: EASE });
        this._tween(e.fire, [
          { transform: 'scaleX(0)', opacity: 1, easing: EASE },
          { transform: 'scaleX(1)', opacity: 1, offset: 0.27 },
          { transform: 'scaleX(1)', opacity: 1, offset: 0.45, easing: 'ease-in' },
          { transform: 'scaleX(1)', opacity: keep ? 1 : 0 }], { duration: 1250, delay: d });
        this._tween(e.halo, [
          { transform: 'scaleX(0)', opacity: 0, easing: EASE },
          { transform: 'scaleX(1)', opacity: 1, offset: 0.3 },
          { transform: 'scaleX(1)', opacity: keep ? 1 : 0 }], { duration: 1500, delay: d });
      });
      if (settle) this._later(() => { this._lit = lit; this._enableNow(true); }, 640 + 600 + 1500);
    }

    /* now: the notch for the visitor's time of day stays lit */
    _enableNow(animated) {
      this._nowOn = true;
      this._applyNow(animated);
      clearInterval(this._tick);
      this._tick = setInterval(() => this._applyNow(true), 60000);
    }
    _applyNow(animated) {
      const p = this.period(), prev = this._lit;
      ORDER.forEach(n => this.$[n].halo.classList.toggle('is-breathing', n === p && !this.reduced));
      if (p === prev && animated) return;
      this._lit = p;
      if (!animated || this.reduced) {
        ORDER.forEach(n => this._set(n, n === p ? { fire: 1, fo: 1, halo: 1, ho: 1 } : { fire: 0, fo: 0, halo: 0, ho: 0 }));
        return;
      }
      if (prev) {
        const e = this.$[prev];
        this._tween(e.fire, [{ transform: 'scaleX(1)', opacity: 1 }, { transform: 'scaleX(1)', opacity: 0 }], { duration: 380, easing: 'ease-out' });
        this._tween(e.halo, [{ transform: 'scaleX(1)', opacity: 1 }, { transform: 'scaleX(1)', opacity: 0 }], { duration: 380, easing: 'ease-out' });
      }
      const e = this.$[p];
      this._tween(e.fire, [{ transform: 'scaleX(0)', opacity: 1 }, { transform: 'scaleX(1)', opacity: 1 }], { duration: 480, delay: prev ? 120 : 0, easing: EASE });
      this._tween(e.halo, [{ transform: 'scaleX(0)', opacity: 0 }, { transform: 'scaleX(1)', opacity: 1 }], { duration: 700, delay: prev ? 120 : 0, easing: EASE });
    }

    /* hover: fire runs through all three cuts, morning to evening */
    _hover() {
      const t = this.closest('a,button') || this;
      const go = () => this._ignite();
      t.addEventListener('pointerenter', go);
      t.addEventListener('focusin', go);
      this._off.push(() => { t.removeEventListener('pointerenter', go); t.removeEventListener('focusin', go); });
    }
    _ignite() {
      if (this._igniting || this.reduced ) return;
      this._igniting = true;
      ORDER.forEach((n, i) => {
        const e = this.$[n], keep = this._nowOn && n === this._lit, d = i * 110;
        this._tween(e.fire, [
          { transform: 'scaleX(0)', opacity: 1, easing: EASE },
          { transform: 'scaleX(1)', opacity: 1, offset: 0.35 },
          { transform: 'scaleX(1)', opacity: 1, offset: 0.6, easing: 'ease-in' },
          { transform: 'scaleX(1)', opacity: keep ? 1 : 0 }], { duration: 950, delay: d });
        this._tween(e.halo, [
          { transform: 'scaleX(0)', opacity: 0, easing: EASE },
          { transform: 'scaleX(1)', opacity: 1, offset: 0.35 },
          { transform: 'scaleX(1)', opacity: keep ? 1 : 0 }], { duration: 1100, delay: d });
      });
      this._later(() => { this._igniting = false; }, 2 * 110 + 1100);
    }

    /* loop: a continuous morning-afternoon-evening cycle for loading states */
    _loop() {
      if (this.reduced) { ORDER.forEach(n => this._set(n, { fire: 1, fo: 1, halo: 1, ho: 0.6 })); return; }
      const D = 2600;
      ORDER.forEach((n, i) => {
        const s = i * 0.16, e = this.$[n];
        this._anim(e.fire, [
          { offset: 0, transform: 'scaleX(0)', opacity: 1 },
          { offset: s, transform: 'scaleX(0)', opacity: 1, easing: EASE },
          { offset: s + 0.14, transform: 'scaleX(1)', opacity: 1 },
          { offset: 0.74, transform: 'scaleX(1)', opacity: 1, easing: 'ease-in' },
          { offset: 0.9, transform: 'scaleX(1)', opacity: 0 },
          { offset: 1, transform: 'scaleX(1)', opacity: 0 }], { duration: D, iterations: Infinity });
        this._anim(e.halo, [
          { offset: 0, transform: 'scaleX(0)', opacity: 0 },
          { offset: s, transform: 'scaleX(0)', opacity: 0, easing: EASE },
          { offset: s + 0.14, transform: 'scaleX(1)', opacity: 1 },
          { offset: 0.74, transform: 'scaleX(1)', opacity: 0.7, easing: 'ease-in' },
          { offset: 0.9, transform: 'scaleX(1)', opacity: 0 },
          { offset: 1, transform: 'scaleX(1)', opacity: 0 }], { duration: D, iterations: Infinity });
      });
    }

    /* scroll: the cuts fill with fire as the reader moves through the page */
    _scroll() {
      const sel = this.getAttribute('scroll-target');
      const el = sel ? document.querySelector(sel) : null;
      const src = el || window;
      const update = () => {
        this._raf = 0;
        let p;
        if (el) { const max = el.scrollHeight - el.clientHeight; p = max > 0 ? el.scrollTop / max : 0; }
        else { const max = document.documentElement.scrollHeight - innerHeight; p = max > 0 ? scrollY / max : 0; }
        ORDER.forEach((n, i) => {
          const f = Math.min(1, Math.max(0, p * 3 - i));
          this._set(n, { fire: f, fo: f > 0 ? 1 : 0, halo: f, ho: f > 0 && f < 1 ? 1 : f >= 1 ? 0.45 : 0 });
        });
        this.dataset.progress = Math.round(p * 100);
      };
      const on = () => { if (!this._raf) this._raf = requestAnimationFrame(update); };
      src.addEventListener('scroll', on, { passive: true });
      window.addEventListener('resize', on);
      this._off.push(() => { src.removeEventListener('scroll', on); window.removeEventListener('resize', on); });
      update();
    }
  }
  customElements.define('adf-wordmark', ADFWordmark);
})();
